var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65,
    filter: "url(#map-pin_svg__a)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 44.5,
    rx: 4,
    ry: 3.5,
    fill: "#0B3E21"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#map-pin_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "map-pin_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2C10.178 2 3 9.461 3 18.636c0 11.498 14.098 24.316 14.698 24.856.376.338.838.508 1.302.508.464 0 .926-.17 1.302-.508.6-.54 14.698-13.358 14.698-24.856C35 9.461 27.822 2 19 2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2C10.178 2 3 9.461 3 18.636c0 11.498 14.098 24.316 14.698 24.856.376.338.838.508 1.302.508.464 0 .926-.17 1.302-.508.6-.54 14.698-13.358 14.698-24.856C35 9.461 27.822 2 19 2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.698 43.492-1.338 1.487 1.338-1.487Zm2.604 0 1.337 1.487-1.337-1.487ZM19 0C9 0 1 8.43 1 18.636h4C5 10.492 11.355 4 19 4V0ZM1 18.636c0 6.454 3.896 12.99 7.535 17.752 3.706 4.849 7.483 8.282 7.825 8.59l2.675-2.973c-.257-.231-3.83-3.477-7.322-8.046C8.153 29.302 5 23.68 5 18.636H1ZM16.36 44.98A3.941 3.941 0 0 0 19 46v-4c.013 0 .025.002.034.006l.007.003-.006-.004-2.674 2.974ZM19 46c.96 0 1.898-.355 2.64-1.021l-2.675-2.974-.006.004.007-.003A.097.097 0 0 1 19 42v4Zm2.64-1.021c.342-.309 4.119-3.742 7.825-8.591C33.105 31.626 37 25.09 37 18.636h-4c0 5.044-3.153 10.666-6.713 15.323-3.493 4.57-7.065 7.815-7.322 8.046l2.675 2.974ZM37 18.636C37 8.431 29 0 19 0v4c7.645 0 14 6.492 14 14.636h4Z",
    fill: "#008545",
    mask: "url(#map-pin_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 6,
    fill: "#008545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "map-pin_svg__a",
    x: 11,
    y: 37,
    width: 16,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5173:84143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "map-pin_svg__b",
    x: 0,
    y: 0,
    width: 38,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5173:84143"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_5173:84143",
    result: "effect2_dropShadow_5173:84143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5173:84143",
    result: "shape"
  })))));
};
export default SvgMapPin;